<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module title="기본정보(담당자 정보)" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['department', 'com_name', 'rank', 'writer_name', 'date']" />

    <!-- 종사자 정보 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 종사자 정보</h5>
      <div class="writeGridContainer">
        <div v-if="!isPrint">
          <div>종사자(ID) 선택</div>
          <EmployeeSelector v-model="form.inputA_1" @select="onSelectEmployee" />
        </div>
        <div v-if="!isPrint"></div>
        <div v-if="!isPrint"></div>
        <div>
          <div>구분(설립)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" readonly />
        </div>
        <div>
          <div>학교(기관)명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input v-else v-model="form.inputA_3" readonly />
        </div>
        <div>
          <div>부서</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <ml-input v-else v-model="form.inputA_4" readonly />
        </div>
        <div>
          <div>구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" readonly />
        </div>
        <div>
          <div>직종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <ml-input v-else v-model="form.inputA_6" readonly />
        </div>
        <div>
          <div>성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
          <ml-input v-else v-model="form.inputA_7" readonly />
        </div>
        <div>
          <div>연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>
          <ml-input v-else v-model="form.inputA_8" readonly />
        </div>
      </div>
    </div>

    <!-- 일반건강검진 정보 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 일반건강검진 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>실시 유무</div>
          <radio-text-input
            :readonly="board.readonly"
            :isPrint="isPrint"
            radioName="radio_1"
            :renderData="[
              { textInput: false, value: '실시' },
              { textInput: false, value: '미실시' },
            ]"
            v-model="form.inputB_1"
          />
        </div>
        <div></div>
        <div></div>
        <fragment v-if="!!form.inputB_1.value && form.inputB_1.value === '실시'">
          <div>
            <div>검진일</div>
            <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
            <date-selector v-else v-model="form.inputB_2" :readonly="board.readonly" />
          </div>
          <div></div>
          <div></div>
        </fragment>
        <div class="writeGridLineItem">
          <div>비고</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_3 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_3" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import DateSelector from "@/components/selector/DateSelector";
import RadioTextInput from "@/components/radio/RadioTextInput";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    EmployeeSelector,
    DateSelector,
    RadioTextInput,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",

        inputB_1: {},
        inputB_2: "",
        inputB_3: "",

        fileList: [],
      },
    };
  },
  methods: {
    onSelectEmployee(data) {
      HttpRequest.get(`/api/v1/field/${data.company_id}`).then((response) => {
        this.form.inputA_2 = response.facility_category.cat3;
      });

      this.form.inputA_3 = data.fields[0].field_name;
      this.form.inputA_4 = data.company.com_name;
      this.form.inputA_5 = data.job_category;
      this.form.inputA_6 = data.employment_type;
      this.form.inputA_7 = data.full_name;
      this.form.inputA_8 = data.contact_number;
    },
  },
};
</script>

<style scoped lang="scss"></style>
